import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const [theme, setTheme] = useState(
  localStorage.getItem('theme') || 'light'
);

useEffect(() => {
  document.documentElement.setAttribute('data-theme', theme);
  localStorage.setItem('theme', theme);
}, [theme]);

const toggleTheme = () => {
  setTheme((currentTheme) =>
    currentTheme === 'light' ? 'dark' : 'light'
  );
};

  return (
    <header className="header">

      {/* ── Top Bar ─────────────────────────────────────────────── */}
   


      {/* ── Main Header ─────────────────────────────────────────── */}
      <div className="header-main">
        <div className="container">

          <div className="header-content">

            {/* Logo */}
            <Link
              to="/"
              className="logo"
              onClick={closeMenu}
            >
              <div className="logo-mark">
                <img
                  src="/logo.png"
                  alt="Annapurna Axis Trading Private Limited"
                  className="logo-img"
                />
              </div>

              <div className="logo-text-group">
                <span className="logo-text">
                  Annapurna Axis
                </span>

                <span className="logo-tagline">
                  Trading Private Limited
                </span>
                 
              </div>
            </Link>


            {/* Mobile Menu Button */}
            <button
              className={`mobile-menu-btn ${isMenuOpen ? 'open' : ''}`}
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Toggle navigation menu"
              aria-expanded={isMenuOpen}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>


            {/* Navigation */}
           
            <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>

              <Link
                to="/"
                className={isActive('/') ? 'active' : ''}
                onClick={closeMenu}
              >
                Home
              </Link>

              <Link
                to="/about"
                className={isActive('/about') ? 'active' : ''}
                onClick={closeMenu}
              >
                About Us
              </Link>

              <Link
                to="/contact"
                className={isActive('/contact') ? 'active' : ''}
                onClick={closeMenu}
              >
                Contact
              </Link>
              
              <Link
                to="/contact"
                className="nav-quote-btn"
                onClick={closeMenu}
              >

                Request a Quote
              </Link>

            </nav>

          </div>

        </div>
      </div>
       <div className="header-topbar">
        <div className="container">
          <div className="topbar-content">

            <div className="topbar-left">

              <span className="topbar-item">
                  <i className="fab fa-whatsapp"></i>
                <a  href="https://wa.me/9779860105010"
                 target="_blank"
    rel="noreferrer">
   
                  +977 9860105010
                </a>
              </span>


              <span className="topbar-item">

                  <i className="fab fa-weixin"></i>
                <a href="tel:+86 15030709205 ">
                  +86 15030709205
                </a>
              </span>

              <span className="topbar-item">
                <i className="fas fa-envelope"></i>
                <a href="mailto:annapurnaaxis@gmail.com">
                  annapurnaaxis@gmail.com
                </a>
              </span>

              <span className="topbar-item topbar-hours">
                <i className="fas fa-clock"></i>
                <span>Mon–Sat: 9:00 AM – 6:00 PM</span>
              </span>

            </div>

            <div className="topbar-right">
              <a
                href="https://www.facebook.com/bikal2"
                target="_blank"
                rel="noreferrer"
                className="social-link"
                aria-label="Facebook"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
            </div>




          </div>
        </div>
      </div>  

    </header>
  );
};

export default Header;